import { Component, ElementRef, EventEmitter, Input, OnInit,AfterViewInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonServiceService } from '../common-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-master-creation',
  templateUrl: './master-creation.component.html',
  styleUrls: ['./master-creation.component.scss']
})
export class MasterCreationComponent implements AfterViewInit {
  @Input() masterType;
  submitted: boolean = false;
  groupList: any;
  showMessage: boolean = false;
  createdMasterCode: ''
	alertType = '';
  keyword = 'name';
	message: string = ``;
  stateArr: any = [];
  countryArr: any = [];
	salesPersonArr: any;
	cityArr: any = [];
  masterForm: FormGroup;
  warningMessage = '';
  categoryOptions: string[] = [];
    sourceOptions: string[] = [];
	showCategoryField: boolean = false;
    showSourceField: boolean = false;
  @ViewChild("confirmCreateModal", { static: true }) confirmCreateModal : ElementRef;
  @ViewChild("closeCreateModal", { static: true }) closeCreateModal : ElementRef;
  @ViewChild("accountAc", { static: true }) accountAc;
  @Output() callSetFormData : EventEmitter<any> = new EventEmitter();
  @Output() closeModal : EventEmitter<any> = new EventEmitter();
	@ViewChild('salesPersonAC',{static : true}) salesPersonAC;
    @ViewChild('openWarningModal') openWarningModal!: ElementRef;
  @ViewChild('closeWarningModal', { static: true }) closeWarningModalBtn: ElementRef;
  

  @Input() masterCreationModal;
  @Input() currentMasterName;
  constructor(private fb: FormBuilder, public commonService: CommonServiceService, private elementRef: ElementRef ) {
    
  }
  

 async ngOnInit(){
    this.masterForm = this.fb.group({
			parent_id: ['28', Validators.required],
			address_1: [''],
			gst_number: [''],
			gst_expiry_date: [''],
			mobile_no: [''],
			primary_email: [''],
			name: ['', Validators.required],
      account_name: [''],
      "2_ltr_code": [''],
			"3_ltr_code": [''],
      state_id: [''],
			state_name: [''],
      city_id: [''],
			city_name: [''],
			country_id: ['101'],
			country: [''],
			vat_number: [''],
			telephone: [''],
			secondary_email: [''],
			pan_number: [''],
			account_legal_name: [''],
			contact_person: [''],
			sales_person: [''],
			sales_person_id: [''],
			sales_person_name: [''],
      category_list: [],
      source_list:[],
			client_type: ['master'],
			parent_account_code : [''],
			is_memo_account:[false],
			is_branch:[false],
		})
    
    this.getGroups()
		this.getCountries()
		this.getStates('101')

    if(this.masterType && this.masterType == 'client'){
      this.getAccountingCompany()
    }

    let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
    let sales_person_manager = globalSettingConfig.filter(el=>el.group=='CLIENT')
		if(sales_person_manager.length){
			let sales_person = sales_person_manager[0].json_doc.value.filter(el=>el.key=='sales_person_mandate')
			
			if(sales_person.length){
				if(sales_person[0].value == 'true'){
					this.masterForm.controls['sales_person'].setValidators(Validators.required)
					this.masterForm.controls['sales_person_name'].setValidators(Validators.required)
					this.masterForm.controls['category_list'].setValidators(Validators.required)
					this.masterForm.controls['source_list'].setValidators(Validators.required)	
					this.masterForm.controls['sales_person'].updateValueAndValidity();
					this.masterForm.controls['sales_person_name'].updateValueAndValidity();
					this.masterForm.controls['category_list'].updateValueAndValidity();
					this.masterForm.controls['source_list'].updateValueAndValidity();

				}
			}
		}
    let transaction_config = globalSettingConfig.filter(el => el.group == 'CLIENT CATEGORY AND SOURCE')
		if (transaction_config && transaction_config.length > 0) {
			let categoryListConfig = transaction_config[0].json_doc["value"].filter(el => el.key == 'Category List')
			let sourceListConfig = transaction_config[0].json_doc["value"].filter(el => el.key == 'Source List')

			if (categoryListConfig && categoryListConfig.length > 0) {
				this.categoryOptions = categoryListConfig[0].value.split(',').map(item => item.trim());
				this.showCategoryField = this.categoryOptions.length > 0;
			}

			if (sourceListConfig && sourceListConfig.length > 0) {
				this.sourceOptions = sourceListConfig[0].value.split(',').map(item => item.trim());
				this.showSourceField = this.sourceOptions.length > 0;
			}
		}
  }

  ngAfterViewInit() {
    const inputElement = this.elementRef.nativeElement.querySelector('#master_name');
    console.log('inputElement',inputElement);
    
    inputElement.focus();
}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.currentMasterName && this.masterForm && this.masterForm.controls) {
      let currentValue = changes.currentMasterName.currentValue
      this.masterForm.controls.name.setValue(currentValue)
    }

    if(changes && changes.masterType && this.masterForm && this.masterForm.controls) {
      let masterTypeCurrValue = changes.masterType.currentValue;
      let selectedParentId;
      if(masterTypeCurrValue == 'client' ) {
        let sundryDebtorsAccount = this.groupList.find(item => item.account_code == 'SA0000005')
        selectedParentId = sundryDebtorsAccount.id;
        this.getAccountingCompany()
      }else if(masterTypeCurrValue == 'supplier') {
        let sundryCreditorsAccount = this.groupList.find(item => item.account_code == 'SL0000036')
        selectedParentId = sundryCreditorsAccount.id;
      }
      this.masterForm.controls.parent_id.setValue(selectedParentId)
    }
  }

  getCountries() {
		this.commonService.getOkount(`location/country`).subscribe(res => {
			this.countryArr = res
		})
	}


  saveMaster(override = false) {
    this.submitted = true;
    this.openConfirmationModal();
    if(this.masterForm.invalid) {
      this.showMessage = true
      this.alertType = 'warning-box';
      this.message = 'Please fill mandatory fields.'
      return false;
    }else{
      let formValues = this.masterForm.value
			if (formValues.sales_person_name && formValues.sales_person_name.employee_id != undefined) {
				formValues['sales_person_id'] = formValues.sales_person_name.employee_id
				formValues['sales_person'] = formValues.sales_person_name.account_code
				formValues['sales_person_name'] = formValues.sales_person_name.name
			}
    }
    
    let formData = this.formatDataForCreation()
    console.log("formData",formData)
    const payload: any = { ...this.masterForm.value };
			if (override) {
				formData['overrideDuplicate'] = true;
			}

    let url = `${environment.okountUrl}/${this.masterType ? this.masterType.toLowerCase() : ''}`
    this.commonService.postRequest(url, formData).subscribe(res => {
      if (res['status'] === 'duplicate_no_warning') {
					this.warningMessage = res['message'];
					this.openWarningModal.nativeElement.click();
					return;
				}
      this.callSetFormData.emit(res[0])
      this.resetForm();
      this.createdMasterCode = res[0].account_code ?  res[0].account_code : ''
      // this.masterCreationModal.nativeElement.click()
      this.closeModal.emit()
      this.alertType = 'success-box';
				this.message = 'Client saved successfully with account code. :'
				// this.openSuccessModal.nativeElement.click()
    }, error => {
      this.showMessage = true
      this.alertType = 'error-box';
      this.createdMasterCode = ""
      this.message = `Failed to create ${this.masterType}.`
    })
    
  }
  closeWarningModal(): void {
		this.warningMessage = '';
		this.closeWarningModalBtn.nativeElement.click();
	}


  openConfirmationModal() {
    this.confirmCreateModal.nativeElement.click()
  }

  getGroups() {
		this.commonService.getOkount('v3account/getallsuperparents').subscribe(res => {
			this.groupList = res
		}, err => {

		})
	}
  
  hideError() {
		this.showMessage = false
	}

  formatDataForCreation() {
    let formValues = this.masterForm.value;

    let clientObj = {
      "parent_id" : formValues.parent_id ? formValues.parent_id : null,
      "name": formValues.name ? formValues.name : "",
      "gst_number" : formValues.gst_number ? formValues.gst_number : null,
      "gst_expiry_date" : formValues.gst_expiry_date ? formValues.gst_expiry_date : null,
      "primary_email" : formValues.primary_email ? formValues.primary_email : null,
      "mobile_no": formValues.mobile_no ? formValues.mobile_no : null,
      "address_1": formValues.address_1 ? formValues.address_1 : null,
      "city_id": formValues.city_id ? formValues.city_id : null,
      "city_name": formValues.city_name ? formValues.city_name : null,
      "country_id": formValues.country_id ? formValues.country_id : null,
      "country": formValues.country ? formValues.country : null,
      "vat_number": formValues.vat_number ? formValues.vat_number : null,
      "telephone": formValues.telephone ? formValues.telephone : null,
      "secondary_email": formValues.secondary_email ? formValues.secondary_email : null,
      "pan_number": formValues.pan_number ? formValues.pan_number : null,
      "balance": formValues.balance ? formValues.balance : null,
      "remarks": formValues.remarks ? formValues.remarks : null,
      "account_legal_name": formValues.account_legal_name ? formValues.account_legal_name : null,
      "contact_person": formValues.contact_person ? formValues.contact_person : null,
      "balance_type": formValues.balance_type ? formValues.balance_type : null,
      "sales_person": formValues.sales_person ? formValues.sales_person : null,
      "sales_person_id": formValues.sales_person_id ? formValues.sales_person_id : null,
      "sales_person_name": formValues.sales_person_name ? formValues.sales_person_name : null,
      "category_list": formValues.category_list ? formValues.category_list : null,
      "source_list": formValues.source_list ? formValues.source_list : null,

      
    }
    
    if(this.masterType == 'client') {
      clientObj['state_id'] = formValues['state_id'] ? formValues['state_id'] : null
      clientObj['state_name'] = formValues['state_name'] ? formValues['state_name'] : null
      clientObj['country_id'] = '101'
      clientObj['country'] = 'India'

    }
    if(this.masterType == 'supplier' || this.masterType == 'client' || this.masterType == 'hotel') {
      return clientObj;
    }

    let obj = {
      "parent_id" : formValues.parent_id ? formValues.parent_id : null,
      "account_name": formValues.name ? formValues.name : ""
    }

    if(this.masterType == 'airline') {
      obj['2_ltr_code'] = formValues['2_ltr_code'] ? formValues['2_ltr_code'] : null
      obj['3_ltr_code'] = formValues['3_ltr_code'] ? formValues['3_ltr_code'] : null
    }
    return obj;

  }

  resetForm() {
    this.masterForm = this.fb.group({
			parent_id: ['28', Validators.required],
			address_1: [''],
			gst_number: [''],
			gst_expiry_date: [''],
			mobile_no: [''],
			primary_email: [''],
			name: ['', Validators.required],
      account_name: [''],
      "2_ltr_code": [''],
			"3_ltr_code": [''],
      state_id: [''],
			state_name: [''],
      city_id: [''],
      city_name: [''],
      country_id: ['101'],
      country: [''],
      vat_number: [''],
      telephone: [''],
      secondary_email: [''],
      pan_number: [''],
      account_legal_name: [''],
      contact_person: [''],
      sales_person: [''],
      sales_person_id: [''],
      sales_person_name: [''],
      category_list: [],
      source_list: [],
      client_type: ['master'],

		})
  }

  getStates(country_id) {
		this.commonService.getOkount(`location/states?country_id=${country_id}`).subscribe(res => {
			this.stateArr = res
		})
	}

  focusAccountAc(){
    if(this.accountAc && this.accountAc.focus) {
      this.accountAc.focus();
    }
  }
  
  getCities(state_id) {
		let selectedState = this.stateArr.filter(option => {
			return option.location_id == Number(state_id);
		})
		if (selectedState.length > 0) {
			this.masterForm.controls.state_name.setValue(selectedState[0].name)
		}
	}

  getAccountingCompany() {
		try {
			this.commonService.getOkount('util/accounting-company').subscribe(async (res) => {
				if(res) {
					if(res['state_name']) {
						this.masterForm.controls.state_name.setValue(res['state_name'])
					}
          if(res['state_id']) {
						this.masterForm.controls.state_id.setValue(res['state_id'])
					}
				}
			})
		} catch (error) {
			console.log('Error occured in getInvoice due to : ', error)
		}
	}

  getSalesPerson(value) {
		if (value.length > 2) {
			this.commonService.getOkount(`employee/autocomplete?name_like=${value.toUpperCase()}`).subscribe(res => {
				this.salesPersonArr = res
			}, err => {
			})
		}
	}

  focusSalesPerson(e): void {
		e.stopPropagation();
		this.salesPersonAC.focus();
	}

  getCityName(city_id) {
		let selectedCity = this.cityArr.filter(option => {
			return option.location_id == Number(city_id);
		})
		if (selectedCity.length > 0) {
			this.masterForm.controls.city_name.setValue(selectedCity[0].name)
		}
	}

  selectSalesPerson(value) {
		try {
			this.masterForm.controls['sales_person'].setValue(value.account_code)
			this.masterForm.controls['sales_person_id'].setValue(value.id)
			this.masterForm.controls['sales_person_name'].setValue(value.name)
		} catch (error) {

		}
	}
}
